import React from 'react';
import Radium from 'radium';
import { browserHistory } from 'react-router';
import StyleDecorator from '../StyleDecorator';
import { paths } from '../../routes';
import Link from './Link';
import translate from '../../locale/translate';

const style = {
	button: {
		display: 'block',
		marginTop: '24px',
	},
};

const RootPageBackLink = () => {
	return (
		<Link
			style={style.button}
			onTouchTap={() => browserHistory.push(paths.APP_ROOT)}
		>
			{translate('BACK')}
		</Link>
	);
};

export default StyleDecorator(Radium(RootPageBackLink));



// WEBPACK FOOTER //
// ./src/components/links/RootPageBackLink.js